import { ArrowUpRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import type { Project } from '../types/content';
import { ResponsiveImage } from './ResponsiveImage';
import { Reveal } from './Reveal';
import { ProjectFacts } from './ProjectFacts';
import { ImageComparison } from './ImageComparison';

export function ProjectRow({ project, reverse = false }: { project: Project; reverse?: boolean }) {
  const isAsphalt = project.slug.startsWith('asfalto-');
  const hasComparison = isAsphalt && project.media.length === 2;
  const href = isAsphalt ? `/projetos/asfalto#${project.slug}` : project.area === 'investimento-privado' ? `/investimentos#${project.slug}` : `/${project.area}#${project.slug}`;
  return (
    <article className={`project-row ${reverse ? 'project-row--reverse' : ''}`} id={project.slug}>
      <Reveal className="project-row__copy">
        
        <h2><Link to={href}>{project.title}</Link></h2>
        <p>{project.summary}</p>
        <ProjectFacts project={project} />
        
        {isAsphalt && <Link className="project-link" to={href}>Abrir projeto <ArrowUpRight size={18} /></Link>}
      </Reveal>
      <Reveal className={`project-row__media ${!hasComparison && project.media.length > 1 ? 'project-row__media--collection' : ''}`} delay={0.08}>
        {hasComparison ? <ImageComparison before={project.media[0]} after={project.media[1]} /> : project.media.length ? (
          <div className="project-media-grid">
            {project.media.map((item, index) => (
              <Link to={href} aria-label={`Ver detalhes de ${project.title}`} key={item.original} className={index === 0 ? 'project-media-grid__lead' : undefined}>
                <ResponsiveImage media={item} sizes={project.media.length > 1 ? "(max-width: 800px) 78vw, 25vw" : "(max-width: 800px) 100vw, 52vw"} />
              </Link>
            ))}
          </div>
        ) : <div className="project-media-placeholder"><span>Registro visual não fornecido separadamente</span></div>}
      </Reveal>
    </article>
  );
}
